var map = {
	"./logo-alphabet.svg": 1855,
	"./logo-amazon-2.svg": 1856,
	"./logo-amazon.svg": 1857,
	"./logo-azercell.svg": 1858,
	"./logo-bank-of-america.svg": 1859,
	"./logo-barclays.svg": 1860,
	"./logo-bnp-paribas.svg": 1861,
	"./logo-booking.svg": 1862,
	"./logo-citibank.svg": 1863,
	"./logo-coca-cola.svg": 1864,
	"./logo-deloitte.svg": 1865,
	"./logo-experian.svg": 1866,
	"./logo-facebook.svg": 1867,
	"./logo-goldman-sacks.svg": 1868,
	"./logo-google.svg": 1869,
	"./logo-h.svg": 1870,
	"./logo-infineon.svg": 1871,
	"./logo-instagram.svg": 1872,
	"./logo-jp-morgan.svg": 1873,
	"./logo-jti.svg": 1874,
	"./logo-linkedin.svg": 1875,
	"./logo-meta.svg": 1876,
	"./logo-oracle.svg": 1877,
	"./logo-paypal.svg": 1878,
	"./logo-pwc.svg": 1879,
	"./logo-tesla.svg": 1880,
	"./logo-visa.svg": 1881,
	"./logo-walmart.svg": 1882,
	"./logo-youtube.svg": 1883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1854;